require('../bootstrap');

window.performPostRequest = function(e) {
	document.getElementById('login-form').classList.add('d-none');
	document.getElementById('login-spinner').classList.remove('d-none');

	let resultElement = document.getElementById('postResult');
	let extraErrorText = document.getElementById('extra_error_text');
	let email = document.getElementById('modal_email').value;
	let password = document.getElementById('modal_password').value;

	axios.post('/login',{
	    email: email,
		password: password,
	}).then((response)=>{
		console.log(response);
	    window.location = response.data;
	}).catch((error)=>{
		document.getElementById('login-form').classList.remove('d-none');
		document.getElementById('login-spinner').classList.add('d-none');
		console.log(JSON.stringify(error.response.data));
		resultElement.innerHTML = generateErrorHTMLOutput(error.response.data);
		resultElement.style.display = "block";
		extraErrorText.style.display = "block";
	});
	e.preventDefault();
}

const modalLogin = document.getElementById('modal_login_form');
if (modalLogin) {
	modalLogin.addEventListener('submit', performPostRequest);
}

function generateErrorHTMLOutput(data) {
	let messages = '';
	for (let key in data.errors) {
		// skip loop if the property is from prototype
		if (!data.errors.hasOwnProperty(key)) continue;

		let obj = data.errors[key];
		for (let prop in obj) {
			// skip loop if the property is from prototype
			if(!obj.hasOwnProperty(prop)) continue;

			// your code
			messages += '<p>' + obj[prop] + '</p>';
		}
	}
	return messages;
}
